'use client';

import { c as _c } from "react/compiler-runtime";
import { TextLink } from '@algoacademy/design-system/web/typography/Text';
import { ArrowRightIcon } from '@heroicons/react/16/solid';
const EXTERNAL_NAV_LINKS = [{
  href: '/',
  label: 'O AlgoAcademy'
}, {
  href: '/app',
  label: 'Aplikacja'
}] as const;
type NavbarMobileExternalLinksProps = {
  onNavigate?: () => void;
};
export function NavbarMobileExternalLinks(t0) {
  const $ = _c(4);
  const {
    onNavigate
  } = t0;
  let t1;
  if ($[0] !== onNavigate) {
    t1 = EXTERNAL_NAV_LINKS.map(link => <TextLink key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" onClick={onNavigate} className="gap-2 text-contentColorPrimary underline decoration-contentColorPrimary underline-offset-2">{link.label}<ArrowRightIcon className="size-4" /></TextLink>);
    $[0] = onNavigate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <nav className="flex flex-col gap-3">{t1}</nav>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}